import { ThemeVars } from '@mysten/dapp-kit';

export const theme: ThemeVars = {
	blurs: {
		modalOverlay: 'blur(0)',
	},
	backgroundColors: {
		primaryButton: 'var(--primary)',
		primaryButtonHover: 'color-mix(in srgb, var(--primary) 88%, var(--foreground) 12%)',
		outlineButtonHover: 'color-mix(in srgb, var(--background) 90%, var(--foreground) 10%)',
		walletItemHover: 'color-mix(in srgb, var(--primary) 12%, transparent)',
		walletItemSelected: 'color-mix(in srgb, var(--primary) 18%, var(--card) 82%)',
		modalOverlay: 'color-mix(in srgb, var(--inverted) 18%, transparent)',
		modalPrimary: 'var(--card)',
		modalSecondary: 'color-mix(in srgb, var(--accent) 65%, var(--card) 35%)',
		iconButton: 'transparent',
		iconButtonHover: 'color-mix(in srgb, var(--foreground) 12%, transparent)',
		dropdownMenu: 'var(--popover)',
		dropdownMenuSeparator: 'var(--border)',
	},
	borderColors: {
		outlineButton: 'var(--border)',
	},
	colors: {
		primaryButton: 'var(--primary-foreground)',
		outlineButton: 'var(--foreground)',
		body: 'var(--foreground)',
		bodyMuted: 'var(--muted-foreground)',
		bodyDanger: 'var(--destructive)',
		iconButton: 'var(--foreground)',
	},
	radii: {
		small: 'calc(var(--radius) * 0.35)',
		medium: 'calc(var(--radius) * 0.5)',
		large: 'calc(var(--radius) * 0.75)',
		xlarge: 'var(--radius)',
	},
	shadows: {
		primaryButton: 'var(--shadow-sm)',
		walletItemSelected: 'var(--shadow-xs)',
	},
	fontWeights: {
		normal: '400',
		medium: '500',
		bold: '600',
	},
	fontSizes: {
		small: '0.875rem',
		medium: '1rem',
		large: '1.125rem',
		xlarge: '1.25rem',
	},
	typography: {
		fontFamily: 'var(--font-sans)',
		fontStyle: 'normal',
		lineHeight: '1.4',
		letterSpacing: 'var(--tracking-normal)',
	},
};
